<template>
  <v-container
    id="agency"
    fluid
    tag="section"
  >
    <filter-form :filter-form="filterForm"/>
    <agency-table :agencyList="agencyList"/>
    <v-row class="mt-4">
      <v-col
        cols="12"
        sm="6"
      />
      <v-col
        cols="12"
        sm="6"
      >
        <v-pagination
          v-if="totalItem > limit"
          v-model="currentPage"
          class="justify-sm-end"
          :length="getTotalItem(totalItem, limit)"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import FilterForm from './components/FilterForm.vue'
  import AgencyTable from './components/AgencyTable'
  import RepositoryFactory from '../../repositories/RepositoryFactory'
  const AgencyRepository = RepositoryFactory.get('agency')
  export default {
    components: { AgencyTable, FilterForm },
    data () {
      return {
        filterForm: {
          keyword: '',
          phone: ''
        },
        agencyList: [],
        currentPage: 1,
        limit: 10,
        totalItem: 0,
        loading: true,
      }
    },
    watch: {
      currentPage: {
        handler () {
          this.getAgencyList()
        },
      },
      limit: {
        handler () {
          if (this.currentPage === 1) {
            this.getAgencyList()
          } else {
            this.currentPage = 1
          }
        },
      },
    },
    async created () {
      this.getAgencyList();
      Bus.$on('agency-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.currentPage = 1
        this.getAgencyList()
      })
      Bus.$on('agency-reload', () => {
        this.getAgencyList()
      })
    },
    beforeDestroy () {
      Bus.$off('agency-list-filter')
    },
    methods: {
      async getAgencyList () {
        this.loading = true
        const params = {
          limit: this.limit,
          page: this.currentPage - 1,
          name: this.filterForm.name,
          phone: this.filterForm.phone,
          status: this.filterForm.status
        }
        const loader = this.$loading.show()
        const response = await AgencyRepository.list(params)
        loader.hide()
        this.loading = false
        if (response.success) {
          this.agencyList = _.get(response, 'data', [])
          this.totalItem = response.totalItem
        }
      },
    },
  }
</script>
<style scoped>
.v-application .text-start {
    text-align: unset !important;
}
tbody {
  height: calc(100vh - 280px) !important;overflow-y: auto !important;
}
</style>